export default class PivotFADefinition {
  #factribFactor;
  #factribPeriod;
  #key;

  constructor({ factribFactor, factribPeriod }) {
    this.#factribFactor = factribFactor;
    this.#factribPeriod = factribPeriod;
    this.#key = [this.#factribFactor, this.#factribPeriod].join("_");
  }

  copy = () => {
    return {
      factribFactor: this.factribFactor,
      factribPeriod: this.factribPeriod,
    };
  };

  get factribFactor() {
    return this.#factribFactor;
  }

  setFactribFactor = (value) =>
    new PivotFADefinition({
      ...this.copy(),
      factribFactor: value,
    });

  get factribPeriod() {
    return this.#factribPeriod;
  }

  setFactribPeriod = (value) =>
    new PivotFADefinition({
      ...this.copy(),
      factribPeriod: value,
    });

  get key() {
    return this.#key;
  }
}
